export default "__VITE_ASSET__B8O7AnVS__"